module.exports = __webpack_public_path__ + "img/delete-uploader-icon.1e213900.svg";